import { RootState } from '../store'

export const top10SportsListSelector = (state: RootState) =>
  state.sports.data ? state.sports.data.slice(0, 10) : []
export const sportsLoadingSelector = (state: RootState) =>
  state.sports.isLoading
export const sportsErrorSelector = (state: RootState) => state.sports.isError
